export * as Card from './styled/card'
